import { Box, styled } from '@mui/material';

export const StyledTimeContainer = styled(Box)`
    height: 50px;
    min-width: 100px;
    border-radius: 25px;
    background-color: #18537b;
    color: #ffffff;
    padding: 7px 7px 6px;
    text-align: center;
    font-family: 'Saira Condensed', sans-serif;
    font-weight: bold;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : '')};
`;
